import Vue from 'vue'
import Vuex from 'vuex'

// import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    web4open_api: '/web4open_api',
    token: '',
    userInfo: {},
    marketInfo: '',
    city: ''
  },
  mutations: {
    setUserInfo(state, value) {
      state.userInfo = value
    },
    setMarketInfo(state, info) {
      state.marketInfo = info
      window.sessionStorage.setItem('marketInfo', JSON.stringify(info))
    },
    getMarketInfo(state) {
      var marketInfo = JSON.parse(window.sessionStorage.getItem('marketInfo'))
      if (marketInfo) {
        state.marketInfo = marketInfo
      }
    },
    setCity(state, value) {
      console.log(value)
      state.city = value
    }
  },
  actions: {
    // async getCityList(store) {
    //   const { data } = await axios.get(store.state.web4open_api + '/web/config/listArea')
    //   if (data.success) {
    //     store.commit('setCiryList', data.data.list)
    //   }
    // }
  },
  modules: {}
})
